import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  type: 'object',
  properties: {
    collectDate: {
      type: 'string',
      title: 'Data odbioru karty',
      format: 'date',
      fieldRequired: true,
      calc: {
        when: '!this.collectionDate',
        func: '$methods.moment().format("YYYY-MM-DD")'
      }
    }
  }
};
